import api from "!../../../../../../.yarn/__virtual__/style-loader-virtual-d9093cce15/0/cache/style-loader-npm-2.0.0-b9a5c4a2aa-129f8d7124.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../.yarn/__virtual__/css-loader-virtual-93e32c1c9f/0/cache/css-loader-npm-7.1.2-7540f12884-ddde22fb10.zip/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../.yarn/__virtual__/sass-loader-virtual-c8f09a7c68/0/cache/sass-loader-npm-17.0.1-b8fccd20b7-c5e97f75f6.zip/node_modules/sass-loader/dist/cjs/index.js??ruleSet[1].rules[1].use[2]!./styles.module.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};